import React from 'react';
import styled from 'styled-components';
import WhoAreWe from '../../Elements/WhoAreWe';
import Herosection from '../../Elements/Herosection'
import Featured from '../../Elements/Feature'
import TestimonialSlider from '../../Elements/Testimonial';
import WhyChooseUs from '../../Elements/WhyChooseUs';
import Partners from '../../Elements/Partner';

const Home  = () => (
  <>
  <Herosection/>
  <WhoAreWe/>
  <Featured />
  <TestimonialSlider />
  <Partners />

  </>
  
);

export default Home;
